export const api = {
  GET_LIST_BY_USER: '/inspections/getListByUser',
};
